import { stringField, booleanField, optionField, hiddenField } from 'common/utils/form/fieldTypes';

export const config = {
  name: stringField(),
  label: stringField(),
  for_performance_reports: booleanField({ initialValue: false }),
  color: optionField(),
  active: booleanField(),
  organizations: {
    id: hiddenField(),
    name: stringField(),
    active: booleanField({ initialValue: false })
  }
};

export default config;
